import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TodoService } from '../../todo.service';
import { LocalUserService } from 'app/main/shared/services/localUser';
import { OrganizationServices } from 'app/main/shared/services/organization.services';

@Component({
  selector: 'todo-share-list',
  templateUrl: './share-list.component.html',
  styleUrls: ['./share-list.component.scss']
})
export class ShareListComponent implements OnInit {
  progress = true;
  userId: string;

  isSave: boolean = false
  orgId: string;

  orgUsers: any[] = [];
  users: string[] = []
  isLoading = false;

  // sharedUserNames: {
  //   id: string,
  //   name: string
  // }[] = [];

  @Output()
  refresh: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(
    private todoService: TodoService,
    private localStore: LocalUserService,
    private organizationServices: OrganizationServices,

    public dialogRef: MatDialogRef<ShareListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.userId = localStore.getUserId();
  }

  ngOnInit() {
    // this.orgId = this.localStore.getOrganizationId();
    // this.getAllUsers(this.orgId)
  }

  // getAllUsers(orgID: string) {
  //   this.organizationServices.getUsersInOrganization(orgID)
  //     .subscribe(page => {
  //       this.orgUsers = page || [];
  //       this.setSharedUsersNames();
  //     });
  // }

  getShare() {
    this.progress = true;
    this.todoService.getShared(this.userId)
      .subscribe(data => {
        // data = this.project.shared_with
        this.progress = false;
      })
  }

  selectedList($event) {
    this.users = $event.map(item => item.id);
  }

  updateShare() {
    this.progress = true;
    let model = {
      user_ids: this.users
    }
    this.todoService.updateShare(this.userId, this.data.project.id, model)
      .subscribe(task => {

        this.refresh.emit();
        this.progress = false;
      })
    this.onNoClick()
  }

  removeShare() {
    this.progress = true;
    let model = {
      user_ids: []
    }
    this.todoService.updateShare(this.userId, this.data.project.id, model)
      .subscribe(task => {
        this.data.project.shared_with = null;
        this.refresh.emit();
        this.progress = false;
        this.isSave = true
      })
    this.onNoClick()
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  // setSharedUsersNames() {
  //   if (!this.orgUsers && !this.orgUsers.length) return;
  //   this.sharedUserNames = [];
  //   this.data.project.shared_with.forEach((userId) => {
  //     let user = this.orgUsers.find(user => user.id == userId)
  //     if (user) {
  //       let item = {
  //         id: user.id,
  //         name: user.first_name + user.last_name
  //       }
  //       this.sharedUserNames.push(item);
  //     }
  //   })
  // }

}



// WEBPACK FOOTER //
// ./src/app/main/content/common/todo-tab/components/share-list/share-list.component.ts